export default __webpack_public_path__ + "static/media/ic_canada.a83dc580.svg";